import { MarginSizeProperty } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { Flex } from '../../summary/components/Flex.js';
import { PDFOnly } from '../../summary/components/PDFOnly.js';

export const SummarySection = ({
  children,
  marginBottom = '4rem',
  shouldBreak = true,
}: PropsWithChildren<{
  marginBottom?: MarginSizeProperty;
  shouldBreak?: boolean;
}>) => (
  <Flex flexDirection="column" marginBottom={marginBottom} break={shouldBreak} width="100%">
    {children}
    <PDFOnly>
      <Flex style={{ height: '64px' }} />
    </PDFOnly>
  </Flex>
);
